export default "<div class=\"vfs-card-container\">\n  <ng-content></ng-content>\n</div>\n";